/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WhichPageEnum } from './WhichPageEnum';
import { WhichPageEnumFromJSON, WhichPageEnumFromJSONTyped, WhichPageEnumToJSON } from './WhichPageEnum';

/**
 *
 * @export
 * @interface PatchedComment
 */
export interface PatchedComment {
  /**
   *
   * @type {number}
   * @memberof PatchedComment
   */
  readonly id?: number;
  /**
   *
   * @type {number}
   * @memberof PatchedComment
   */
  useCase?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedComment
   */
  content?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedComment
   */
  readonly user?: string;
  /**
   *
   * @type {WhichPageEnum}
   * @memberof PatchedComment
   */
  whichPage?: WhichPageEnum;
  /**
   *
   * @type {Date}
   * @memberof PatchedComment
   */
  readonly timestamp?: Date;
  /**
   *
   * @type {Date}
   * @memberof PatchedComment
   */
  readonly lastModified?: Date;
}

/**
 * Check if a given object implements the PatchedComment interface.
 */
export function instanceOfPatchedComment(value: object): value is PatchedComment {
  return true;
}

export function PatchedCommentFromJSON(json: any): PatchedComment {
  return PatchedCommentFromJSONTyped(json, false);
}

export function PatchedCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedComment {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    useCase: json['use_case'] == null ? undefined : json['use_case'],
    content: json['content'] == null ? undefined : json['content'],
    user: json['user'] == null ? undefined : json['user'],
    whichPage: json['which_page'] == null ? undefined : WhichPageEnumFromJSON(json['which_page']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    lastModified: json['last_modified'] == null ? undefined : new Date(json['last_modified']),
  };
}

export function PatchedCommentToJSON(
  value?: Omit<PatchedComment, 'id' | 'user' | 'timestamp' | 'lastModified'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    use_case: value['useCase'],
    content: value['content'],
    which_page: WhichPageEnumToJSON(value['whichPage']),
  };
}
